export default __webpack_public_path__ + "a2a9856f833c95022654c4820ac07bbd.png";